import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Lock, CheckCircle2, Sparkles } from 'lucide-react';
import { useCheckout } from './checkout-context';
export const ExitUpsellPopup = () => {
  const {
    exitPopupOpen,
    closeExitPopup,
    acceptExitOffer,
    declineExitOffer
  } = useCheckout();
  return <AnimatePresence data-id="element-109">
      {exitPopupOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-3 bg-black/70 backdrop-blur-sm" onClick={closeExitPopup} role="dialog" aria-modal="true" aria-label="Oferta especial" data-id="element-110">
          <motion.div initial={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.9,
        opacity: 0,
        y: 20
      }} transition={{
        type: 'spring',
        stiffness: 260,
        damping: 22
      }} onClick={e => e.stopPropagation()} className="relative w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-111">
            {/* Close */}
            <button onClick={closeExitPopup} aria-label="Cerrar" className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full bg-white/80 text-slate-500 hover:text-brand-navy hover:bg-white flex items-center justify-center shadow-md transition-colors" data-id="element-112">
              <X className="w-4 h-4" data-id="element-113" />
            </button>

            {/* Header banner */}
            <div className="bg-brand-pink text-white text-center px-5 pt-6 pb-4" data-id="element-114">
              <div className="inline-block bg-brand-yellow text-brand-navy text-[11px] font-bold px-3 py-1 rounded-full mb-2 transform -rotate-2 shadow-md blink-badge" data-id="element-115">
                ⏳ ¡SOLO EN ESTA PANTALLA!
              </div>
              <h2 className="font-heading text-2xl leading-tight" data-id="element-116">
                🛑 ¡Esperá!
              </h2>
            </div>

            <div className="p-5" data-id="element-117">
              {/* Discount badge */}
              <div className="flex justify-center mb-3" data-id="element-118">
                <span className="inline-flex items-center gap-1.5 bg-brand-green text-white font-bold text-sm px-4 py-1.5 rounded-full shadow-lg blink-badge text-center" data-id="element-119">
                  <Sparkles className="w-4 h-4 flex-shrink-0" data-id="element-120" /> LLEVÁ TODO CON
                  DESCUENTO EXTRA
                </span>
              </div>

              {/* Main copy */}
              <p className="text-slate-700 text-center text-sm mb-3" data-id="element-121">
                Sumá <strong data-id="element-122">Recorta, Arma y Pega</strong> al combo y dale a tu
                peque todas las herramientas para aprender jugando.
              </p>

              {/* Compact included summary */}
              <div className="bg-brand-gray rounded-xl p-3 mb-4 flex items-start gap-2" data-id="element-123">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-124" />
                <p className="text-xs text-slate-600 leading-snug" data-id="element-125">
                  <strong className="text-brand-navy" data-id="element-126">
                    Kit 15 en 1 + 6 bonos de regalo + Recorta, Arma y Pega
                  </strong>{' '}
                  — todo en un solo pago.
                </p>
              </div>

              {/* Pricing block */}
              <div className="text-center mb-4" data-id="element-127">
                <span className="text-slate-400 line-through text-base font-bold mr-2" data-id="element-128">
                  $31.998
                </span>
                <span className="font-heading text-4xl text-brand-pink align-middle" data-id="element-129">
                  $28.998,3
                </span>
                <p className="text-[11px] text-slate-500 flex items-center justify-center gap-1 mt-1" data-id="element-130">
                  <Lock className="w-3 h-3 text-brand-green" data-id="element-131" />
                  Precio especial solo en esta pantalla
                </p>
              </div>

              {/* CTAs */}
              <button onClick={acceptExitOffer} className="w-full bg-brand-pink text-white font-bold text-base py-3.5 px-5 rounded-full shadow-pink mb-2 transition-transform hover:scale-[1.02] active:scale-95 glow-pulse leading-tight" data-id="element-132">
                ¡SÍ! Quiero el Paquete Completo por $28.998,3
              </button>
              <button onClick={declineExitOffer} className="w-full text-slate-500 font-medium text-xs py-1.5 hover:text-slate-700 transition-colors" data-id="element-133">
                No gracias, continuar sin los extras →
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};